import { createSlice } from '@reduxjs/toolkit';

import { RECORDING_REQUEST_MODAL_STAGE } from '@recording/data/recordingRequestModalStage';

const initialState = {
  modalStage: RECORDING_REQUEST_MODAL_STAGE.notOpen,
  recordingRequest: {},
};

const recordingRequest = createSlice({
  name: 'recordingRequest',
  initialState,
  reducers: {
    setModalStage(state, action) {
      state.modalStage = action.payload;
    },
    setRecordingRequest(state, action) {
      state.recordingRequest = action.payload;
    },
  },
});

export const { setModalStage, setRecordingRequest } = recordingRequest.actions;

export default recordingRequest.reducer;
